import React, { memo } from "react";
import { useTranslation, Trans } from "react-i18next";
import { P1 } from "@talentbait/shared-components";

import DraftCampaignStepLayout from "./DraftCampaignStepLayout";

const DraftCampaignChannelsInfoStep = (props) => {
  const { t } = useTranslation();

  return (
    <DraftCampaignStepLayout
      header={t("Save time: Publish in many channels with just one click ⏰")}
      {...props}
    >
      <Trans parent={P1}>
        With TalentBait, you gain access to <b>15 social media channels</b> without the hassle of
        setting up individual company accounts for each. We simplify identification by utilizing job
        pages under our management, like <b>Jobhappier</b>, which is used for different channels.
      </Trans>
      <Trans parent={P1}>
        You might encounter a diverse set of <b>job pages</b>, but rest assured, before your
        campaign is live, we'll expertly select the most fitting option from over 1000 available
        choices for you.
      </Trans>
    </DraftCampaignStepLayout>
  );
};

export default memo(DraftCampaignChannelsInfoStep);
